<template>
  <div class="add-remote-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose"
      :close-on-click-modal="false"
      height="300px"
      custom-class="add-remote-dialog"
    >
      <!-- <div class="remote-box">
        <el-input
          v-model="form.remote_visual"
          placeholder="输入演员名称"
        ></el-input>
      </div> -->
      <div class="priority">
        <span>优先级</span>
        <el-radio-group v-model="form.priority">
          <el-radio :label="2">高</el-radio>
          <el-radio :label="1">中</el-radio>
          <el-radio :label="0">低</el-radio>
        </el-radio-group>
      </div>
      <div class="deadline" v-if="type !== 'remote_operation'">
        <span>截止时间</span>
        <el-date-picker
          v-model="form.end_at"
          type="date"
          placeholder="选择截止时间"
          format="yyyy-MM-dd"
          value-format="timestamp"
          size="small"
        ></el-date-picker>
      </div>
      <div class="task-description" v-if="type !== 'remote_operation'">
        <span>任务描述</span>
        <el-input
          v-model="form.description"
          type="textarea"
          :rows="3"
          placeholder="请输入任务描述"
          maxlength="500"
          show-word-limit
        ></el-input>
      </div>
      <div class="remote-visual" v-loading="loading">
        <div class="visual-list">
          <div v-if="remoteVisualOptions.length === 0" class="empty-data">
            <el-empty description="暂无数据" :image-size="100"></el-empty>
          </div>
          <template v-else>
            <div
              v-for="item in remoteVisualOptions"
              :key="item.id"
              :class="['visual-item', { selected: form.user_id === item.id }]"
              @click="toggleVisual(item.id)"
            >
              {{ item.user_name }}
              <i
                v-if="form.user_id === item.id"
                class="el-icon-check checkmark"
              ></i>
            </div>
          </template>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="editRemote" size="small"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api";

export default {
  props: {
    media_type: {
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        ids: [],
        priority: '',
        user_id: '',
        description: '',
        end_at: '',
      },
      activeNames: undefined,
      title: "",
      type: "",
      tags: [],
      tagStr: [],
      remoteVisualOptions: [],
      selectedVisual: null,
      loading: false,
      editType: '',
    };
  },
  methods: {
    // 打开弹窗并赋值需要修改
    open(videoIds, editType, type) {
      this.dialogVisible = true;
      this.form.ids = videoIds || [];
      const titleMap = {
        edit: {
          remote_visual: '批量更新远程视觉',
          remote_operation: '批量更新远程运营'
        },
        add: {
          remote_visual: '添加远程视觉', 
          remote_operation: '添加远程运营'
        }
      };
      this.title = titleMap[editType][type] || '';
      this.type = type || "";
      this.editType = editType || '';
      this.getLists();
    },
    getLists() {
      let params = {
        page: 1,
        size: 1000,
        product_name: "",
        user_type: this.type === 'remote_operation' ? 3 : 2,
        status: 'normal'
      };
      this.loading = true;
      API.getAdminStratorsList(params)
        .then((res) => {
          this.loading = false;
          if (res.code === 0 && res.data.data) {
            // this.remoteVisualOptions = res.data.data;
            this.remoteVisualOptions = res.data.data.filter(item => item.status === 'normal');
          }
        })
        .catch(() => {
          this.remoteVisualOptions = [];
          this.loading = false;
        });
    },
    // 切换远程视觉选择状态（单选）
    toggleVisual(visualId) {
      if (this.form.user_id === visualId) {
        // 如果已选中，则取消选中
        this.form.user_id = null;
      } else {
        // 如果未选中，则选中（单选，会取消其他选择）
        this.form.user_id = visualId;
      }
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.form.ids = [];
      this.form.user_id = "";
      this.form.priority = "";
      this.form.end_at = "";
      this.form.description = "";
      this.form.end_at = "";
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
    },
    async editRemote () {
        if(!this.form.end_at && this.type !== 'remote_operation'){
            this.$message({
                message: "请选择截止时间",
                type: "warning",
            });
            return;
        }
        if(!this.form.priority && this.type === 'remote_operation'){
            this.$message({
                message: "请选择优先级",
                type: "warning",
            });
            return;
        }
        if(!this.form.user_id && this.type === 'remote_operation'){
            this.$message({
                message: "请选择人员",
                type: "warning",
            });
            return;
        }
        
      if (this.type === "remote_operation") {
        let req = {
          vids: this.form.ids,
          user_id: this.form.user_id,
          urgent: this.form.priority,
          media_type: this.media_type,
          description: this.form.description
        };

        const res = this.editType === 'edit' ? await API.taskPointBatchUpdate({
          ids: this.form.ids,
          user_id: this.form.user_id,
          urgent: this.form.priority,
          description: this.form.description,
        }) : await API.taskPointBatchCreate(req)
          if (res.code === 0) {
            this.$message({
              message: "设置成功",
              type: "success",
            });
            this.$emit("handlerClose");
            this.$emit("handlerSave");
            this.handleClose();
            return;
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
        
      } else {
        let req = {
          vids: this.form.ids,
          user_id: this.form.user_id,
          urgent: this.form.priority,
          media_type: this.media_type,
          end_at: this.form.end_at / 1000,
          desc: this.form.description,
        };
        const res = this.editType === 'edit' ? await API.taskFillingBatchUpdate({
          ids: this.form.ids,
          user_id: this.form.user_id,
          urgent: this.form.priority,
          end_at: this.form.end_at / 1000,
          desc: this.form.description,
        }) : await API.taskFillingCreate(req)
          if (res.code === 0) {
            this.$message({
              message: "设置成功",
              type: "success",
            });
            this.$emit("handlerClose");
            this.$emit("handlerSave");
            this.handleClose();
            return;
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
      }
    }
  },
};
</script>

<style scoped lang="scss">
.add-remote-box {
  .remote-visual,
  .remote-operation {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .el-select {
      width: 100%;
    }
    .visual-list {
      width: 100%;
      max-height: 200px;
      overflow-y: auto;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      padding: 5px;
      .visual-item {
        padding: 8px 12px;
        margin: 2px 0;
        border-radius: 4px;
        cursor: pointer;
        transition: all 0.3s;
        border: 1px solid transparent;
        user-select: none;
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
        &:hover {
          background-color: #f5f7fa;
        }
        &.selected {
          background-color: #409eff;
          color: white;
          border-color: #409eff;
        }
        .checkmark {
          font-size: 16px;
          font-weight: bold;
        }
      }
    }
  }
  .priority {
    display: flex;
    align-items: center;
    // justify-content: center;
    margin: 15px 0;
    span {
      margin-right: 10px;
      width: 100px;
    }
    .el-radio {
      margin-right: 10px;
    }
  }
  .deadline {
    display: flex;
    align-items: center;
    margin: 15px 0;
    span {
      margin-right: 10px;
      width: 100px;
    }
  }
  .task-description {
    display: flex;
    align-items: flex-start;
    margin: 15px 0;
    span {
      margin-right: 10px;
      width: 100px;
      margin-top: 8px;
    }
    .el-textarea {
      flex: 1;
    }
  }
  .dialog-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    .el-button {
      width: 100px;
    }
  }
  :deep(.add-remote-dialog) {
    height: auto !important;
  }
}
</style>
